import React, { ReactElement } from 'react';
import { useLocation, useNavigate, useParams } from 'react-router';
import Uuid from '../../../model/Uuid';
import Secured from '../../Secured';
import UserRole from '../../../model/currentuser/UserRole';
import vyhodnotit from '../icons/vyhodnotit.svg';
import routes from '../../../routing/routes';
import { processInCorrectStates } from '../../../function/permissions';
import { useUserContext } from '../../../context/UserContext';
import { useErrorMessageContext } from '../../../context/ErrorMessageContext';

interface Props {
  assignedList?: Array<Uuid>;
  setAssignedList: (assignedList: Array<Uuid>) => void;
  setOpenDropdown: (open: boolean) => void;
}

const HromadneVyhodnotitButton = ({
  assignedList = [], setAssignedList, setOpenDropdown,
}: Props): ReactElement => {
  // @ts-ignore
  const { type, year, index } = useParams<{ type: string, year: number, index: number }>();
  const navigate = useNavigate();
  const location = useLocation();
  const { legislationProcess } = useUserContext();
  const { displayError } = useErrorMessageContext();

  const handleClick = async (): Promise<void> => {
    if (assignedList.length === 0) {
      displayError('Prosím označte aspoň jednu pripomienku.');
      setOpenDropdown(false);
    } else {
      if (location.pathname.endsWith(routes.pripomienky.list.withParams(type, year, index))) {
        navigate(routes.pripomienky.hromadneVyhodnotit.withParams(type, year, index, assignedList));
      } else {
        navigate(routes.hromadnePripomienky.hromadneVyhodnotit.withParams(type, year, index, assignedList));
      }
      setAssignedList([]);
      setOpenDropdown(false);
    }
  };

  return (
    <Secured
      allowForRoles={[UserRole.VYHODNOCOVATEL]}
      additionalCheck={processInCorrectStates(legislationProcess)
      && location && location.pathname.includes('zobraz')}
    >
      <li key="Označené vyhodnotiť" className="action-item">
        <div className="icon-wrapper">
          <img src={vyhodnotit} className="icon" alt="Označené vyhodnotiť" />
        </div>
        <button
          className="button-inline-text idsk-link assign-me-list-button"
          type="button"
          onClick={handleClick}
        >Označené vyhodnotiť
        </button>
      </li>
    </Secured>
  );
};

export default HromadneVyhodnotitButton;
